import { render, staticRenderFns } from "./CreditDebitNotes.vue?vue&type=template&id=6524d268&"
import script from "./CreditDebitNotes.vue?vue&type=script&lang=js&"
export * from "./CreditDebitNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports